var _path, _g, _rect, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDrawer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9000_199",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 14,
    width: 22,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.1 15.0727L21.4308 15.0727L21.4308 19.4981C21.4308 21.0998 20.1324 22.3981 18.5308 22.3981L3 22.3981C1.39838 22.3981 0.1 21.0998 0.1 19.4981L0.1 15.0727Z",
    fill: "white",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9000_199)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.9088 11.6719L34.0276 24.3569",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M11.1777 11.9336L33.2965 24.6186",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10.4473 12.1953L32.5661 24.8803",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M9.71655 12.457L31.8354 25.142",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.98584 12.7148L31.1046 25.3998",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M8.25537 12.9766L30.3742 25.6616",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M7.52441 13.2383L29.6432 25.9233",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.79358 13.5L28.9124 26.185",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6.06287 13.7617L28.1817 26.4467",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M5.33191 14.0195L27.4507 26.7045",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M4.60168 14.2852L26.7205 26.9702",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.87097 14.543L25.9898 27.228",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M3.13989 14.8086L25.2587 27.4936",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M2.40942 15.0664L24.5282 27.7514",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M1.67871 15.332L23.7975 28.017",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.947998 15.5898L23.0668 28.2748",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M0.217041 15.8477L22.3358 28.5327",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-0.513428 16.1133L21.6054 28.7983",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-1.24426 16.3711L20.8745 29.0561",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-1.97498 16.6328L20.1438 29.3178",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-2.70569 16.8945L19.4131 29.5795",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-3.43616 17.1562L18.6826 29.8412",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-4.16711 17.418L17.9517 30.103",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-4.89795 17.6836L17.2208 30.3686",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-5.62866 17.9414L16.4901 30.6264",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M-6.35913 18.2031L15.7597 30.8881",
    stroke: "#B5B5B5",
    strokeWidth: 0.2
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 13.9,
    width: 21.2,
    height: 8.2,
    rx: 2.6,
    stroke: "#B5B5B5",
    strokeWidth: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.4 3.5C0.4 2.06406 1.56406 0.9 3 0.9L19 0.9C20.4359 0.9 21.6 2.06406 21.6 3.5L21.6 16.1L0.4 16.1L0.4 3.5Z",
    fill: "white",
    stroke: "#FFB600",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.4 3.5C0.4 2.06406 1.56406 0.9 3 0.9L19 0.9C20.4359 0.9 21.6 2.06406 21.6 3.5L21.6 13.1L0.4 13.1L0.4 3.5Z",
    fill: "#FFB600",
    fillOpacity: 0.5,
    stroke: "#FFB600",
    strokeWidth: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1236 10.8C10.1236 10.6343 10.2579 10.5 10.4236 10.5L11.5821 10.5C11.7478 10.5 11.8821 10.6343 11.8821 10.8L11.8821 17.0741C11.8821 17.2398 12.0164 17.3741 12.1821 17.3741L13.5475 17.3741C13.8187 17.3741 13.9507 17.7052 13.754 17.8918L11.2107 20.3031C11.0944 20.4133 10.9121 20.4128 10.7965 20.3018L8.25268 17.8601C8.05577 17.6711 8.19306 17.3387 8.46595 17.3437L9.81891 17.3687C9.98675 17.3718 10.1245 17.2366 10.1244 17.0687L10.1236 10.8Z",
    fill: "#FF7A00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDrawer);
export default __webpack_public_path__ + "static/media/ic-drawer.1088a3cb2893ab53fd245b5bbae19c27.svg";
export { ForwardRef as ReactComponent };